import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Nummernsuche (07.10.2026, Ralph): Dokumentnummern mit oder ohne Bindestriche finden,
// z. B. "AB-2026-0029", "ab20260029", "2026-0029", "R-10/26-00001".
export const nummerNormal = (text) => String(text || "").toLowerCase().replace(/[^a-z0-9]/g, "");

export const istNummernSuche = (text) => {
  const n = nummerNormal(text);
  return n.length >= 4 && (n.match(/\d/g) || []).length >= 3;
};

// passt die eingegebene Nummer (ohne Trennzeichen verglichen) zur Dokumentnummer?
export const nummerPasst = (nummer, suche) => {
  const s = nummerNormal(suche);
  return s.length > 0 && nummerNormal(nummer).includes(s);
};

// Treffer ueber alle Dokumentarten (Angebot, Auftrag, Rechnung) inkl. Kunde und Projekte.
// Ohne Finanz-Berechtigung liefert der Server 403 -> leere Liste.
export const useNummernTreffer = (suche) => {
  const [treffer, setTreffer] = useState([]);
  useEffect(() => {
    if (!istNummernSuche(suche)) { setTreffer([]); return undefined; }
    let aktiv = true;
    const t = setTimeout(() => {
      api.get("/modules/dokumente/nummernsuche", { params: { q: suche } })
        .then((r) => { if (aktiv) setTreffer(Array.isArray(r.data) ? r.data : []); })
        .catch(() => { if (aktiv) setTreffer([]); });
    }, 250);
    return () => { aktiv = false; clearTimeout(t); };
  }, [suche]);
  return treffer;
};
